import Cookie from 'js-cookie';
import { AllAnalyticsCookies } from './cookie';
import { TestSupport } from './util/testSupport';
const MAX_CACHE_SIZE = 100;
const COOKIE_NAME = AllAnalyticsCookies.AWC_ANALYTICS_DEBUG.getKey();
const DEBUG_TAG = 'synthetic';
class TestingCache {
  constructor(syntheticFlagOverride, enableTestingCache) {
    this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
    this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
    this._isDebugCookieEnabled = TestingCache.getDebugCookie();
    this.bind();
  }
  saveEvent(event) {
    try {
      if (!event) {
        return;
      }
      this.bind();
      this.addSyntheticTag(event);
      this.cache(event);
    } catch (_unused) {
      // Ignore errors from testing cache.
    }
  }
  bind() {
    if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) {
      return;
    }
    window.testAnalytics = {
      eventCache: [],
      events: () => window.testAnalytics.eventCache,
      clear: () => {
        window.testAnalytics.eventCache = [];
        try {
          localStorage.removeItem('awc.ui.viewed.last.sent');
          localStorage.removeItem('awc-staging.ui.viewed.last.sent');
          localStorage.removeItem('awc-dev.ui.viewed.last.sent');
          localStorage.removeItem('awc-local.ui.viewed.last.sent');
        } catch (_unused2) {
          // Ignore errors from localStorage.
        }
      }
    };
  }
  cache(event) {
    if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) {
      return;
    }
    if (window.testAnalytics.eventCache.length >= MAX_CACHE_SIZE) {
      window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
    }
    window.testAnalytics.eventCache.push(event);
  }
  addSyntheticTag(event) {
    if (!this.shouldSetSyntheticFlag()) {
      return;
    }
    if (event.tags instanceof Array) {
      if (!event.tags.includes(DEBUG_TAG)) {
        event.tags.push(DEBUG_TAG);
      }
    } else {
      event.tags = [DEBUG_TAG];
    }
  }
  shouldCacheEvent() {
    return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
  }
  shouldSetSyntheticFlag() {
    if (this._syntheticFlagOverride !== undefined) {
      return this._syntheticFlagOverride;
    }
    const globalSyntheticOverride = TestSupport.getSyntheticFlagOverride();
    if (globalSyntheticOverride !== undefined) {
      return globalSyntheticOverride;
    }
    return this.shouldCacheEvent();
  }
  static getDebugCookie() {
    try {
      return JSON.parse(Cookie.get(COOKIE_NAME) || 'false') === true;
    } catch (_unused3) {
      Cookie.remove(COOKIE_NAME);
    }
    return false;
  }
}
export default TestingCache;